module.exports = __webpack_public_path__ + "img/customer-support.b55a533a.svg";